const verifyForm = (form: IReservationFields) => {
	// ESTADO POR DEFECTO
	const indexState: boolean[] = [false, false, false, false, false, false, false, false]

	// VERIFICAR CADA ESTADO
	indexState[0] = form.from !== null && form.to !== null
	indexState[1] = form.adults !== 0 || form.children !== 0
	indexState[2] = form.name.length !== 0
	indexState[3] = form.email.length !== 0
	indexState[4] = form.phone.toString().length !== 0 && form.phone !== 0
	indexState[5] = form.region.length !== 0
	indexState[6] = form.room.length !== 0
	indexState[7] = form.pay.length !== 0

	// VERIFICAR SI EL NOMBRE ES CORRECTO
	if (form.name.split(' ').length < 2) indexState[2] = false

	// VERIFICAR SI CONTIENE @
	if (form.email.includes('@')) {
		// VARIABLE TEMPORAL
		let tmp: boolean = false

		// RECORRER EMAIL
		for (let i = 0; i < form.email.length; i++)
			if (i > form.email.indexOf('@') && form.email[i] === '.') tmp = true

		// ASIGNAR TEMPORAL
		indexState[3] = tmp
	}
	// SINO ERROR EN EMAIL
	else indexState[3] = false

	// RETORNAR ESTADOS
	return indexState
}

const formatDate = (date: Date, lang: ILangPackage) => {
	// SHORTHANDS DE DIAS Y MESES
	const daysStr: string[] = lang.daysShort.map((dayS: string) => dayS.substr(0, 3))
	const monthsStr: string[] = lang.months.map((monthS: string) => monthS.substr(0, 3))

	// OBTENER MES Y DIAS
	const month: number | undefined = date.getMonth()
	const day: number | undefined = date.getDay()
	const fullDay: number | undefined = date.getDate()

	// RETORNAR FECHA CON FORMATO
	return `${daysStr[day]}, ${fullDay} ${monthsStr[month]}`
}

// CALCULAR SCROLL TOP
const computeScrollTop = (el: HTMLElement | null, nav?: boolean) =>
	(el?.clientHeight || 0) + (el?.scrollTop || 0) - (nav ? 113 : 0)

// HACER SCROLL
const scrollToHideSection = (el: HTMLElement | null, nav?: boolean) =>
	window.scrollTo({ top: computeScrollTop(el, nav), behavior: 'smooth' })

export { verifyForm, formatDate, computeScrollTop, scrollToHideSection }
